import 'core-js/actual';

import icons from '../../img/icons.svg';
export default class view {
  render(data) {
    if (!data || (Array.isArray(data) && data.lenghth === 0)) {
      return this.renderError();
    }
    try {
      this._data = data;
      const markup = this._generateMarkup();
      /////////////////inserting html element to our dom/////////////////
      this._parentElement.innerHTML = '';
      this._parentElement.insertAdjacentHTML('afterbegin', markup);
    } catch (err) {
      console.error('render fail', err);
    }
  }

  update(data) {
    if (!data || (Array.isArray(data) && data.lenghth === 0)) {
      return this.renderError();
    }
    try {
      this._data = data;
      const newMarkup = this._generateMarkup();
      //converting  markUp string to  dom node which then will be compared to real dom on the page
      const newDOM = document.createRange().createContextualFragment(newMarkup);
      //storing all the elements on that dom in varaiable
      const newElements = Array.from(newDOM.querySelectorAll('*'));
      // console.log(newElements);
      const curElements = Array.from(this._parentElement.querySelectorAll('*'));
      // console.log(curElement);
      // looping elements of both doms real dom on page and virtual dom we created as new newElements using foreach
      newElements.forEach((newEl, i) => {
        const curEl = curElements[i];
        // changing text content in the dom element
        if (
          !newEl.isEqualNode(curEl) &&
          newEl.firstChild?.nodeValue.trim() !== ''
        ) {
          curEl.textContent = newEl.textContent;
        }

        //changing attributes in the dom element
        if (!newEl.isEqualNode(curEl)) {
          //forming a new array and storing attributes from new elements into that array and then looping over that array
          Array.from(newEl.attributes).forEach(attribute => {
            curEl.setAttribute(attribute.name, attribute.value);
          });
        }
      });

      /////////////////inserting html element to our dom/////////////////
      // this._parentElement.innerHTML = '';
      // this._parentElement.insertAdjacentHTML('afterbegin', markup);
    } catch (err) {
      console.error('render fail', err);
    }
  }

  renderSpinner() {
    const markup = `
          <div class="spinner">
              <svg>
                <use href="${icons}#icon-loader"></use>
              </svg>
          </div>
        `;
    this._parentElement.innerHTML = '';
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  renderError(message) {
    message = this._errorMessage;
    const markup = `
              <div class="error">
                <div>
                  <svg>
                    <use href="${icons}#icon-alert-triangle"></use>
                  </svg>
                </div>
                <p>${message}</p>
              </div>
        `;
    this._parentElement.innerHTML = '';
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  renderMessage(message) {
    message = this._message;
    const markup = `
              <div class="error">
                <div>
                  <svg>
                    <use href="${icons}#icon-smile"></use>
                  </svg>
                </div>
                <p>${message}</p>
              </div>
        `;
    this._parentElement.innerHTML = '';
    this._parentElement.insertAdjacentHTML('afterbegin', markup);
  }

  _generateMarkup() {
    const id = window.location.hash.slice(1);
    return `
    ${this._data
      .map(rec => {
        return `
        <li class="preview">
            <a class="preview__link ${
              id === rec.id ? 'preview__link--active' : ''
            }" href="#${rec.id}">
              <figure class="preview__fig">
                <img src="${rec.image}" alt="Test" />
              </figure>
              <div class="preview__data">
                <h4 class="preview__title">${rec.title}</h4>
                <p class="preview__publisher">${rec.publisher}</p>
              </div>
            </a>
          </li>`;
      })
      .join('')}
    `;
  }
}
